// The latest complete filter key owns the state; canceled older reads cannot settle it.
export function createLatestRead() {
  let generation = 0, pending = null, pendingKey, cancel = null, disposed = false;
  function invalidate() {
    generation += 1;
    if (cancel) cancel();
    cancel = null; pending = null; pendingKey = undefined;
  }
  function load(key, start, handlers) {
    if (disposed) return Promise.resolve({ stale: true });
    if (pending && pendingKey === key) return pending;
    invalidate();
    const current = generation; pendingKey = key;
    handlers.onStart();
    pending = Promise.resolve().then(() => {
      if (current !== generation || disposed) return null;
      const request = start(); cancel = request.cancel || null;
      return request.promise || request;
    }).then(response => {
      if (current !== generation || disposed) return { stale: true };
      handlers.onSuccess(response); return { stale: false };
    }).catch(error => {
      if (current !== generation || disposed) return { stale: true };
      handlers.onFailure(error); return { stale: false, error };
    }).finally(() => {
      if (current === generation && !disposed) {
        pending = null; pendingKey = undefined; cancel = null; handlers.onSettled();
      }
    });
    return pending;
  }
  return { load, dispose() { disposed = true; invalidate(); } };
}
